export const Sections = {
  HOME: 0,
  MY_WORK: 1,
  ABOUT_ME: 3,
  CONTACT: 4
}
